import React, { useState, useEffect, useRef, useMemo } from 'react';
import { IoPrintOutline } from "react-icons/io5";
import { usePDF } from "react-to-pdf";
import axios from 'axios';
import Swal from 'sweetalert2';
import Ecobank from '../../../Assets/uba.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToWords } from 'to-words';
import { BASE_URL } from '../../../Components/Styles/API/API';

export default function NewUBACheque() {
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [chequeLoading, setChequeLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [bearer, setBearer] = useState('');
  const [description, setDescription] = useState('');
  const [beneficiary1, setBeneficiary1] = useState('');
  const [beneficiary, setBeneficiary] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const printRef = useRef();

  const { toPDF, targetRef } = usePDF({ filename: "cheque.pdf" });
  const [printed, setPrinted] = useState(false);
  const [totalNetPayInWords, setTotalNetPayInWords] = useState('');
  const location = useLocation();

  // Normalize invoice: accept single object or array
  const rawInvoice = location.state?.invoice;
  const invoices = Array.isArray(rawInvoice) ? rawInvoice : rawInvoice ? [rawInvoice] : [];

  const toWords = new ToWords({
    localeCode: 'en-US',
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        name: 'Naira',
        plural: 'Naira',
        fractionalUnit: { name: 'Kobo', plural: 'Kobo' },
      }
    }
  });

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) setBearer(value);
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => { readData(); }, []);

  const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${bearer}` };

  const handlePrint = () => { window.print(); };

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = String(today.getFullYear());
  const formattedDate = `${day}-${month}-${year}`;
  const dateDigits = formattedDate.split("");

  // ---------- Inline (screen) styles ----------
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      backgroundColor:'#f6e8e8ff',
      height: '100vh'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 672,
      marginBottom: 20,
      padding: '0 20px',
    },
    headerTitle: { margin: 0, fontSize: 24, color: '#2c3e50', marginTop: 20 },
    icon: { fontSize: 28, cursor: 'pointer', color: '#2c3e50', transition: 'color 0.3s ease' },
    chequeWrapper: { marginBottom: 60 },
    cheque: {
      width: 672,
      height: 301.44,
      padding: '10px 20px',
      border: 'none',
      position: 'relative',
      backgroundColor:  '#f8f4f4ff',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    topRow: { display: 'flex', justifyContent: 'space-between', marginTop: 0, padding: 0 },
    chequeNumber: { display: 'flex', justifyContent: 'flex-end', margin: 0, paddingTop: 5, fontSize: 12, color: '#2c3e50' },
    dateBox: { display: 'flex', justifyContent: 'flex-end', marginTop: 30, gap: 4 },
    section: { position: 'relative', display: 'flex', alignItems: 'center', gap: 0 },
    dateLabel: { position: 'absolute', top: -20, left: '50%', transform: 'translateX(-50%)', fontSize: 12 },
    digitBox: {
      width: 28.8, height: 38.4, border: 'none', margin: '0 2px', textAlign: 'center', lineHeight: '18.9px',
      fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', color: '#2c3e50',
    },
    payTo: { display: 'flex', alignItems: 'center', gap: 4, marginTop: 10, position: 'relative' },
    sumOf: { display: 'flex', alignItems: 'center', gap: 4, position: 'relative' },
    payToLabel: { fontSize: 11, textAlign: 'right', width: 70, color: '#2c3e50' },
    sumOfLabel: { fontSize: 11, textAlign: 'right', width: 70, color: '#2c3e50' },
    payToValue: { position: 'absolute', top: '35%', left: '15%', fontWeight: 'bold', fontSize: 18 },
    sumOfLabelValue: { position: 'absolute', top: '47%', left: '15%', fontWeight: 'bold', fontSize: 18 },
    amountBox: { display: 'flex', justifyContent: 'flex-end', marginTop: 30, gap: 4 },
    amountPrefix: { fontSize: 14, lineHeight: '30.24px', color: '#2c3e50' },
    inputBox: {
      width: 196.56, height: 30.24, border: 'none', textAlign: 'left', fontSize: 18, lineHeight: '30.24px',
      paddingLeft: 10, boxSizing: 'border-box', backgroundColor: '#fff', fontWeight: 'bold',
    },
    accountDetails: { fontSize: 12, color: '#2c3e50', position: 'absolute', bottom: 16, left: 20 },
  };

  const printCSS = useMemo(() => `
@media print {
  @page { size: 297mm 210mm; margin: 0; }

  [data-role="container"] {
    background: none !important;
    box-shadow: none !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    padding: 0 !important;
  }

  [data-role="header"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    page-break-after: always !important;
    break-after: page !important;
    position: relative !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  [data-role="cheque"]:last-child { page-break-after: auto !important; break-after: auto !important; }

  /* Hide everything by default inside cheque */
  [data-role="cheque"] * {
    display: none !important;
    visibility: hidden !important;
  }

   /* ⬇️ SHOW RULES — note the added [data-role="cheque"] ancestor to increase specificity */
  [data-role="cheque"] [data-role="payToValue"] {
     display: block !important;
    visibility: visible !important;
    border: none !important;
    background: none !important;
    text-align: left !important;
    position: absolute !important;
    left: 38.5rem !important;
    top: 19.5rem !important;
  white-space: nowrap !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 18px !important;
    
  }

  [data-role="cheque"] [data-role="sumOfLabelValue"] {
     display: block !important;
    visibility: visible !important;
    border: none !important;
    background: none !important;
    text-align: left !important;
    position: absolute !important;
    top: 21.30rem !important;
    left: 38.5rem !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 15px !important;
    white-space: nowrap !important;
    width: 100% !important;
  }

  [data-role="cheque"] [data-role="payTo"] { display: block !important; visibility: visible !important; }
  [data-role="cheque"] [data-role="payToLabel"] { display: none !important; visibility: hidden !important; }
  [data-role="cheque"] [data-role="sumOf"] { display: block !important; visibility: visible !important; }

  [data-role="cheque"] [data-role="topRow"] {
    display: flex !important; visibility: visible !important; color: black !important; border: none !important; background: none !important;
  }

 [data-role="cheque"] [data-role="dateBox"] {
  position: absolute !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
  align-items: flex-start !important;
  visibility: visible !important;
  background: none !important;
  border: none !important;
  top: 15.80rem !important;
  right: -36rem !important;
  color: black !important;
  gap: 0 !important; /* disable global gap */
}

[data-role="cheque"] [data-role="section"]:nth-child(1) {
  margin-right: 1rem !important; /* ⬅️ Space between Day and Month */
}
[data-role="cheque"] [data-role="section"]:nth-child(2) {
  margin-right: 1rem !important; /* ⬅️ Space between Month and Year */
}
[data-role="cheque"] [data-role="section"]:nth-child(3) {
  margin-right: 0 !important; /* last section (Year) */
}

/* Fine-tune the distance between each digit within the same section */
[data-role="cheque"] [data-role="digitBox"] {
  margin: 0 0.1rem !important; /* adjust spacing between digits */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  background: none !important;
  color: black !important;
  border: none !important;
  width: 28px !important;
  height: 38px !important;
}

/* If you want more precise control, use these: */
[data-role="cheque"] [data-role="section"]:nth-child(1) .digitBox {
  transform: translateY(0); /* can nudge day digits vertically */
}
[data-role="cheque"] [data-role="section"]:nth-child(2) .digitBox {
  transform: translateY(0.2rem); /* nudge month digits slightly */
}
[data-role="cheque"] [data-role="section"]:nth-child(3) .digitBox {
  transform: translateY(-0.1rem); /* adjust year digits */
}

  [data-role="cheque"] [data-role="section"] { margin-right: -1px !important; }
  [data-role="cheque"] [data-role="digitBox"] { margin: 0 -4px !important; }
  [data-role="cheque"] [data-role="section"]:first-child { margin-right: 5px !important; }
  [data-role="cheque"] [data-role="section"]:nth-child(2) { margin-right: 10px !important; }
  [data-role="cheque"] [data-role="section"]:last-child { margin-right: 0 !important; }

  [data-role="cheque"] [data-role="dateBox"] * {
    display: flex !important; visibility: visible !important; color: black !important; border: none !important; background: none !important;
  }
  [data-role="cheque"] [data-role="dateLabel"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] [data-role="amountBox"] { display: flex !important; visibility: visible !important; }
  [data-role="cheque"] [data-role="amountPrefix"] { display: none !important; visibility: hidden !important; }

  [data-role="cheque"] [data-role="inputBox"] {
    display: block !important;
    visibility: visible !important;
    border: none !important;
    background: none !important;
    position: absolute !important;
    top: 28.5rem !important;
    right: -35rem !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 18px !important;
  }
}
`, []);

  return (
    <div data-role="container" style={styles.container}>
      <style>{printCSS}</style>

      {/* Header */}
      <div data-role="header" style={styles.header}>
        <div>
          <h2 data-role="headerTitle" style={styles.headerTitle}>CHEQUE PAYMENTS</h2>
        </div>
        <IoPrintOutline
          data-role="icon"
          style={styles.icon}
          onClick={handlePrint}
          onMouseOver={(e) => (e.currentTarget.style.color = '#34495e')}
          onMouseOut={(e) => (e.currentTarget.style.color = '#2c3e50')}
        />
      </div>

      {/* Cheques */}
      {invoices.map((item, index) => (
        <div key={item.uuid || index} style={styles.chequeWrapper} ref={printRef}>
          <div data-role="cheque" style={styles.cheque}>
            {/* Cheque Number */}
            <div data-role="chequeNumber" style={styles.chequeNumber}>
              {item.teller_number || '4981772420'}
            </div>

            {/* Top Row with Date */}
            <div data-role="topRow" style={styles.topRow}>
<img src={Ecobank} style={{height: 100, width: 150, objectFit: 'contain'}}/>
              <div /> {/* optional address/logo area */}

              {/* Date Box */}
              <div data-role="dateBox" style={styles.dateBox}>
                {/* Day */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Day</div>
                  {dateDigits.slice(0, 2).map((digit, i) => (
                    <div key={i} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>

                {/* Month */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Month</div>
                  {dateDigits.slice(3, 5).map((digit, i) => (
                    <div key={i + 2} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>

                {/* Year */}
                <div data-role="section" style={styles.section}>
                  <div data-role="dateLabel" style={styles.dateLabel}>Year</div>
                  {dateDigits.slice(6).map((digit, i) => (
                    <div key={i + 4} data-role="digitBox" style={styles.digitBox}>{digit}</div>
                  ))}
                </div>
              </div>
            </div>

            {/* Pay to */}
            <div data-role="payTo" style={styles.payTo}>
              <p data-role="payToLabel" style={styles.payToLabel}>Pay to</p>
              <p data-role="payToValue" style={styles.payToValue}>{item.particular || ''}</p>
            </div>

            {/* The sum of */}
            <div data-role="sumOf" style={styles.sumOf}>
              <p data-role="sumOfLabel" style={styles.sumOfLabel}>The sum of</p>
              <p data-role="sumOfLabelValue" style={styles.sumOfLabelValue}>
                {item.amount ? toWords.convert(parseFloat(item.amount)) : ""}
              </p>
            </div>

            {/* Amount Box */}
            <div data-role="amountBox" style={styles.amountBox}>
              <p data-role="amountPrefix" style={styles.amountPrefix}>₦</p>
              <div data-role="inputBox" style={styles.inputBox}>
                {item.amount
                  ? parseFloat(item.amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : "0.00"}
              </div>
            </div>

            {/* Account Details */}
            <div data-role="accountDetails" style={styles.accountDetails}>
              THE&nbsp;REDEEMED&nbsp;CHRISTIAN
              <br />
              CHURCH&nbsp;OF&nbsp;GOD
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
